import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { getInitials } from '../../../utils';

const UserAvatar = ({ user, style, size, isDanger = false }) => {

    const isSizeNumber = typeof size === 'number';

    return (
        <Avatar
            style={{
                fontSize: isSizeNumber ? size / 2.5 : 'inherit',
                ...style,
                background: isDanger ? '#D2665A' : '#1677ff',
            }}
            size={size}
        >
            {getInitials(user?.name) || <UserOutlined />}
        </Avatar>
    );
};

export default UserAvatar;
